import { render } from "./TableLoader.vue?vue&type=template&id=0358ff18&scoped=true"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"

import "./TableLoader.vue?vue&type=style&index=0&id=0358ff18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0358ff18"]])

export default __exports__